export const getOptions = (data) => {
  const params = {
    params: {
      "username": data.username,
    },
  };

  if (data.query) {
    params.params = {
      ...params.params,
      ...data.query
    };
  }

  const headers = {
    headers: {
      "Authorization": `Bearer ${data.token}`,
      // "X-Openerp-Session-Id": 'ef5f4fb80776507fc72bc3148ec008b3d1498fe1',
    }
  };

  return { params, headers };
};